import type { CalculatorDescription } from '../../../lib/calculators/calculator-description';
import { CalculatorId } from '../../../lib/calculators/calculator-config';

export const heatmapDescription: CalculatorDescription = {
  id: CalculatorId.Heatmap,
  title: 'Heatmap maker',
  metaTitle: 'Online Heatmap Maker - Create Heat Maps online for Free',
  description: 'Create heatmaps to visualize data density and patterns across two dimensions. Ideal for showing correlations, patterns, and intensity variations in data.',
  metaDescription: 'Make professional heatmaps online. Visualize data intensity and patterns with our free heat map generator. Perfect for showing data distributions.',
  howTo: {
    title: 'How to Create a Heatmap',
    steps: [
      'Enter matrix data or select columns',
      'Choose color gradient scheme',
      'Set cell size and labels',
      'Add title and customize appearance',
      'View and export your heatmap'
    ],
    graphic: {
      description: 'An echarts heatmap with color gradient, plus a shadcn matrix input grid'
    }
  },
  examples: [
    {
      title: 'Website Traffic',
      description: 'Time-based activity patterns',
      dataDescription: 'Hourly website traffic data across days of the week',
      insights: [
        'Shows peak usage times',
        'Displays daily patterns',
        'Identifies quiet periods',
        'Reveals traffic trends'
      ]
    },
    {
      title: 'Correlation Matrix',
      description: 'Variable relationship analysis',
      dataDescription: 'Correlation coefficients between multiple variables',
      insights: [
        'Shows variable relationships',
        'Highlights strong correlations',
        'Displays pattern clusters',
        'Identifies key associations'
      ]
    }
  ],
  relatedCalculators: [
    CalculatorId.BoxPlot,
    CalculatorId.ScatterChart,
    CalculatorId.BarGraph,
    CalculatorId.ColumnChart
  ]
}; 